// Navigation context only: opaque identifiers and allowlisted filters, never
// contact details, credentials, or evidence of authorization.
export const ZAPIER_LEADS_CONTEXT_KEY = 'lpam:zapier-leads-context';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const DATE = /^\d{4}-\d{2}-\d{2}$/;
function storage() { try { return sessionStorage; } catch { return null; } }
export function clearZapierLeadsContext() { try { storage()?.removeItem(ZAPIER_LEADS_CONTEXT_KEY); } catch { /* unavailable */ } }
export function safeLeadsFilters(input = {}) {
  if (!input || typeof input !== 'object' || Array.isArray(input)) input = {};
  const filters = { campaignId: '', adId: '', formId: '', status: '', from: '', to: '', archived: 'exclude' };
  for (const key of ['campaignId', 'formId']) if (UUID.test(input[key] || '')) filters[key] = input[key];
  if (/^[0-9]{1,40}$/.test(input.adId || '')) filters.adId = input.adId;
  if (['new', 'contacted', 'booked', 'lost'].includes(input.status)) filters.status = input.status;
  for (const key of ['from', 'to']) if (DATE.test(input[key] || '') && Number.isFinite(Date.parse(input[key])) && new Date(input[key]).toISOString().slice(0, 10) === input[key]) filters[key] = input[key];
  if (filters.from > filters.to && filters.to) { filters.from = ''; filters.to = ''; }
  if (['exclude', 'include', 'only'].includes(input.archived)) filters.archived = input.archived;
  return filters;
}
export function saveZapierLeadsContext({ companyId, userId, role, leadId, filters }, now = Date.now()) {
  clearZapierLeadsContext();
  if (role !== 'owner' || !UUID.test(companyId) || !UUID.test(userId)) return;
  const value = { companyId, userId, leadId: UUID.test(leadId || '') ? leadId : '', filters: safeLeadsFilters(filters), expiresAt: now + 30 * 60_000 };
  try { storage()?.setItem(ZAPIER_LEADS_CONTEXT_KEY, JSON.stringify(value)); } catch { /* navigation still works */ }
}
export function readZapierLeadsContext({ companyId, userId, role }, now = Date.now()) {
  try {
    const value = JSON.parse(storage()?.getItem(ZAPIER_LEADS_CONTEXT_KEY) || 'null');
    if (!value) return null;
    if (role !== 'owner' || value.companyId !== companyId || value.userId !== userId
      || !UUID.test(companyId) || !UUID.test(userId) || !Number.isFinite(value.expiresAt)
      || value.expiresAt <= now || value.expiresAt > now + 30 * 60_000) { clearZapierLeadsContext(); return null; }
    return { leadId: UUID.test(value.leadId || '') ? value.leadId : '', filters: safeLeadsFilters(value.filters) };
  } catch { clearZapierLeadsContext(); return null; }
}
